import { Link } from 'react-router-dom';
import { guides } from '../data/guides';
import { aiTools, freeTools, tools } from '../data/tools';
import { Seo } from '../lib/seo';

const mainPages = [
  ['Home', '/'], ['All tools', '/tools'], ['Pricing', '/pricing'], ['Plans & credits', '/plans-and-credits'],
  ['Guides', '/guides'], ['FAQ', '/faq'], ['About', '/about'], ['Editorial methodology', '/methodology'], ['Contact', '/contact']
] as const;

const policyPages = [
  ['Privacy policy', '/privacy'], ['Terms of service', '/terms'], ['Acceptable use', '/acceptable-use'],
  ['Refund policy', '/refund-policy'], ['Cookie & storage policy', '/cookies']
] as const;

export function SitemapPage() {
  return (
    <section className="page-section sitemap-page">
      <Seo
        title="Sitemap - Nexhance AI Tools, Guides & Policies"
        description="Browse Nexhance AI image tools, free image utilities, pricing, guides, FAQs, about pages and policy links from one sitemap."
        path="/sitemap"
      />
      <div className="shell">
        <div className="page-hero compact-page-hero">
          <p className="eyebrow">Sitemap</p>
          <h1>Find every important Nexhance AI page from one place.</h1>
          <p>Browse the main product pages, all 25 image tools, the tool-by-tool guide library and the policies that explain privacy, billing, acceptable use and browser storage.</p>
        </div>

        <section className="sitemap-section">
          <div className="section-heading"><p className="eyebrow">Main pages</p><h2>Product and help</h2></div>
          <div className="sitemap-link-grid">
            {mainPages.map(([label, to]) => <Link key={to} to={to}>{label}</Link>)}
          </div>
        </section>

        <section className="sitemap-section">
          <div className="section-heading"><p className="eyebrow">AI image studio</p><h2>{aiTools.length} credit-based AI workflows</h2></div>
          <div className="sitemap-tool-grid">
            {aiTools.map((tool) => <Link key={tool.slug} to={`/tools/${tool.slug}`}><strong>{tool.name}</strong><span>{tool.description}</span></Link>)}
          </div>
        </section>

        <section className="sitemap-section">
          <div className="section-heading"><p className="eyebrow">Free image utilities</p><h2>{freeTools.length} browser tools at 0 credits</h2></div>
          <div className="sitemap-tool-grid">
            {freeTools.map((tool) => <Link key={tool.slug} to={`/tools/${tool.slug}`}><strong>{tool.name}</strong><span>{tool.description}</span></Link>)}
          </div>
        </section>

        <section className="sitemap-section">
          <div className="section-heading"><p className="eyebrow">Image guide library</p><h2>Focused guides grouped by the workflows they support</h2><p>The library prioritizes distinct editorial topics and practical workflows instead of publishing large batches of near-identical pages for every tool.</p></div>
          <div className="sitemap-guide-groups">
            {tools.map((tool) => {
              const related = guides.filter((guide) => guide.relatedTool === tool.slug);
              if (!related.length) return null;
              return (
                <article key={tool.slug}>
                  <h3><Link to={`/tools/${tool.slug}`}>{tool.name}</Link></h3>
                  <div>{related.map((guide) => <Link key={guide.slug} to={`/guides/${guide.slug}`}>{guide.title}</Link>)}</div>
                </article>
              );
            })}
          </div>
        </section>

        <section className="sitemap-section">
          <div className="section-heading"><p className="eyebrow">Policies</p><h2>Privacy, terms and billing rules</h2></div>
          <div className="sitemap-link-grid">
            {policyPages.map(([label, to]) => <Link key={to} to={to}>{label}</Link>)}
            <a href="/sitemap.xml">XML sitemap</a>
          </div>
        </section>
      </div>
    </section>
  );
}
